export const BIRDING_HABITAT_PROFILE_VERSION = 13;

export const TERRAIN_ELEVATION_BANDS = [
    'below_sea_level',
    'lowland',
    'foothills',
    'montane',
    'subalpine',
    'alpine'
] as const;

export type TerrainElevationBand = typeof TERRAIN_ELEVATION_BANDS[number];

export const TERRAIN_ELEVATION_BAND_LABELS: Record<TerrainElevationBand, string> = {
    below_sea_level: 'Below sea level',
    lowland: 'Lowland',
    foothills: 'Foothills',
    montane: 'Montane',
    subalpine: 'Subalpine',
    alpine: 'Alpine'
};

export const HABITAT_FAMILY_LABELS = [
    'Water',
    'Coastal',
    'Wetland',
    'Forest',
    'Shrubland',
    'Grassland',
    'Desert',
    'Urban',
    'Agricultural',
    'Mountain',
    'Mixed'
] as const;

export type HabitatFamilyLabel = typeof HABITAT_FAMILY_LABELS[number];
